import script from "./ContactPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactPhone.vue?vue&type=script&setup=true&lang=js"

import "./ContactPhone.vue?vue&type=style&index=0&id=08a37259&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a37259"]])

export default __exports__